import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { StockBadge, isEligibleStockOrder, stockLinesOf } from "@/components/StockBadge";

// STOCK-PACK-01 · Stock SO/ESO picker then its exact product line (line no. shown).
export function StockPackPicker({ orders, isExport, orderId, lineId, onOrder, onLine, prefix, selCls, errOrder, errLine }) {
  const eligible = orders.filter(o => isEligibleStockOrder(o, isExport));
  const order = eligible.find(o => o.id === orderId);
  const lines = order ? stockLinesOf(order, isExport) : [];
  const no = (o) => (isExport ? o.doc_no : o.order_no) || "—";
  return (
    <div className="space-y-2" data-testid={`${prefix}-stock-picker`}>
      <div>
        <div className="overline mb-1.5 flex items-center gap-1">{isExport ? "Stock ESO" : "Stock SO"} <StockBadge /></div>
        <Select value={orderId || ""} onValueChange={onOrder}>
          <SelectTrigger data-testid={`${prefix}-stock-order`} className={`${selCls} ${errOrder ? "border-red-500" : ""}`}>
            <SelectValue placeholder={`Pick a ${isExport ? "Stock ESO" : "Stock SO"}…`} />
          </SelectTrigger>
          <SelectContent className="bg-[var(--bg-1)] border-[var(--border)] max-h-64">
            {eligible.map(o => <SelectItem key={o.id} value={o.id} data-testid={`${prefix}-stock-order-opt-${no(o)}`}>{no(o)} · STOCK</SelectItem>)}
            {eligible.length === 0 && <div className="px-2 py-1.5 text-xs text-zinc-500">No authorised Stock {isExport ? "ESO" : "SO"}</div>}
          </SelectContent>
        </Select>
      </div>
      <div>
        <div className="overline mb-1.5">Stock line</div>
        <Select value={lineId || ""} onValueChange={onLine} disabled={!order}>
          <SelectTrigger data-testid={`${prefix}-stock-line`} className={`${selCls} ${errLine ? "border-red-500" : ""}`}>
            <SelectValue placeholder={order ? "Pick the product line…" : "Pick the stock order first"} />
          </SelectTrigger>
          <SelectContent className="bg-[var(--bg-1)] border-[var(--border)] max-h-64">
            {lines.map(l => <SelectItem key={l.line_id} value={l.line_id} data-testid={`${prefix}-stock-line-opt-${l.line_no}`}>Line {l.line_no} · {l.code}{l.style_no ? ` · ${l.style_no}` : ""} · {l.qty.toLocaleString("en-IN")} m</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
